
import { ActivatedRoute, Router } from '@angular/router';
import { Jobs } from 'src/app/models/jobs.model';
import { FunctionsService } from '../../services/functions.service';
import { UsersService } from '../../services/users.service';
import { environment } from 'src/environments/environment';
import { Component, Input, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { HttpService } from '../../services/http.service';
import { Candidates } from '../../models/candidates.model';
import { formatDate } from '@angular/common';
import { Companies } from '../../models/companies.model';

@Component({
  selector: 'app-job-details',
  templateUrl: './job-details.component.html',
  styleUrls: ['./job-details.component.scss']
})
export class JobDetailsComponent implements OnInit {
  baseURL = environment.apiUrl;
  jobID: any;
  job: any;
  typeUser: any;
  jobDescribeFile: any;



  @Input() jobList!: Jobs[];
  @Input() typeInterface: string = 'candidat';
  candidates: Candidates;


  constructor(private httpService: HttpService, public functions: FunctionsService, private usersService: UsersService, private router: Router, private route: ActivatedRoute) {
    this.jobID = this.route.snapshot.paramMap.get('jobID');
    this.candidates = this.usersService.getCurrentUser();
    this.typeUser = this.usersService.getUserType();
    if (parseInt(this.jobID) != this.jobID) {
      this.router.navigate(['/not-found']);
    }
    this.typeUser = this.usersService.getUserType();
  }

  ngOnInit() {
    if (localStorage.getItem('jobList') && localStorage.getItem('jobList') != undefined) {
      let list = JSON.parse(localStorage.getItem("jobList") || "[]");

      (this.functions.searchJob(this.jobID, list) == undefined) ? this.router.navigate(['/not-found']) : this.job = this.functions.searchJob(this.jobID, list);

      this.jobDescribeFile = (this.job.getJobDescribeFile() != null) ? this.job.getJobDescribeFile() : '';

    } else {
      this.router.navigate(['/not-found'])
    }
  }

  addJobInBackup(jobID: number) {
    (this.candidates == undefined) ? this.router.navigate(['/connexion']) : this.candidates;

    const backupJobList: Jobs[] = this.candidates.getCandidatesSaveJobs();

    if (backupJobList.length == 0) {
      const jobToAdd: Jobs = this.searchJobByID(jobID);
      (jobToAdd != null) ? this.saveJob(jobID) : false;
    } else {
      if (this.checkJobInBackupList(jobID, backupJobList)) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Cette offre d\'emploi existe déjà dans vos sauvegardes.',
        })
      } else {
        const jobToAdd: Jobs = this.searchJobByID(jobID);
        (jobToAdd != null) ? this.saveJob(jobID) : false;
      }
    }
  }
  saveJob(jobID: number) {
    Swal.fire('Veuillez patientez...');
    this.httpService.saveBackupJob(jobID, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));

          Swal.fire({
            icon: 'success',
            title: 'Excellent!',
            text: 'Offre d\'emploi ajoutée à vos sauvegades',
          })
        }
      },
      (error) => {
        if (error.error.message == 'JOB_ALREADY_SAVE_WITH_THIS_CANDIDATE') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Cette offre existe déjà dans vos sauvegardes.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  checkJobInBackupList(jobID: number, backupList: Jobs[]): boolean {
    let result = false;
    backupList.forEach((element) => {
      const job = new Jobs(element);
      if (job.getId() == jobID) {
        result = true;
      }
    });

    return result;
  }

  searchJobByID(jobID: number): any {
    let jobFind;
    this.jobList.forEach((job: Jobs) => {
      if (job.getId() == jobID) {
        jobFind = job;
      }
    });

    return jobFind;
  }

}
